import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FuncsService {

  static copy<T>(objIn: T): T {
    return JSON.parse(JSON.stringify(objIn));
  }

  // DISTINCT SORTED LIST WITHOUT NULL/UNDEFINED VALUES
  static distinct(listIn: string[], prefix = '', sortAsc = true): string[] {
    const sortCorr = sortAsc ? 1 : -1;
    let listOut = listIn
      .filter((value, index, self) => value && self.indexOf(value) === index)
      .sort((a, b) => a < b ? -1 * sortCorr : 1 * sortCorr);
    if (prefix) {
      listOut = listOut.map((c) => prefix + c);
    }
    return listOut;
  }

}
